import { render, staticRenderFns } from "./mailOpenIcon.vue?vue&type=template&id=4a2918a4&"
import script from "./mailOpenIcon.vue?vue&type=script&lang=js&"
export * from "./mailOpenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports